import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { EJType, useTypesTableContext } from '../../../../TypesTableContext'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateEjTypeMutation } from 'schema'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<EJType> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useTypesTableContext()
  const [create, { loading: creating }] = useCreateEjTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createEJType: {
        type: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: creating || fetching,
    entity: 'Type',
    permission: Permission.CreateEJType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({
        name,
        allowanceDescription,
        users,
        reportTypeId,
      }: CreateEditFormItemsValues) => {
        await create({
          variables: {
            input: {
              projectId,
              name,
              userIds: users?.map(({ value }) => value.toString()),
              reportTypeId: reportTypeId,
              // Required field, so using bang
              allowanceDescription: allowanceDescription!,
            },
          },
        })

        refetch()
      },
    },
  }
}
